import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export default function getAdminUserClientreducer(state = initialState.adminUserClient, action) {
	switch (action.type) {
		case types.GET_ADMIN_USER_CLIENT: {
			return action.response;
		}
		case types.CLEAR_ADMIN_USER: {
			return initialState.adminUserClient;
		}
		default:
			return state;
	}
}
